import { render, staticRenderFns } from "./ReguaEnrollmentBadge.vue?vue&type=template&id=f63752d8&scoped=true&"
import script from "./ReguaEnrollmentBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReguaEnrollmentBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReguaEnrollmentBadge.vue?vue&type=style&index=0&id=f63752d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63752d8",
  null
  
)

export default component.exports